module.exports = __webpack_public_path__ + "static/media/logo-manole.168a38a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-manole.svg
// module id = 331
// module chunks = 0